<template>
    <div class="landing"
         v-lazy:background-image="backgroundImage">
        <div class="content">
            <div class="when">{{when}}</div>
            <!--<div class="where">Zámek Třebušín</div>-->
            <div class="who">{{who}}</div>
        </div>
    </div>

</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "SectionLanding",
        computed: {
            ...mapGetters(['who', 'when']),
            backgroundImage() {
                return {
                    src: '/images/predsvatebni/A&D_103.jpg',
                    loading: '/images/predsvatebni/thumbnails/t_A&D_103.jpg',
                    preLoad: 250 / 166
                }
            }
        }
    };
</script>

<style scoped lang="stylus">
    .landing {
        position: relative;

        height: 100vh;
        background-size: cover;
        background-position: center center;
    }
    .content {
        position: absolute;
        width: 100%;
        height: 100%;

        padding: 0 5vw;

        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-end;
        font-size: 3rem;
    }

    .where, .who, .when {
        color: var(--v-secondary-base);
        text-shadow: 2px 2px #000000;
    }

    .who {
        font-size: 10vw;
    }

    .when {
        font-size: 5vw;
    }

    @media screen and (max-width: 960px) {
        .content {
            justify-content: flex-start;
            align-items: flex-end;
            margin-top: 2rem;
        }
        .who {
            font-size: 13vw;
            display: none;
        }
        .when {
            font-size: 8.5vw;
        }
    }
</style>